import * as React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.less';
import { MicroApp } from 'umi';

interface FMicroApp_SignResourceToNode_Props {
  signedToNode?: (presentableId: string, nodeId: number) => void;
}

function FMicroApp_SignResourceToNode({
  signedToNode,
}: FMicroApp_SignResourceToNode_Props) {
  return ReactDOM.createPortal(
    <MicroApp
      name={
        self.location.host.endsWith('.testfreelog.com')
          ? 'ResourceSignNode_test'
          : 'ResourceSignNode'
      }
      mainAppType={'resourceToNode'}
      mainAppFuncs={{
        signedToNode({ presentableId, nodeId }: any) {
          signedToNode?.(presentableId, nodeId);
        },
      }}
    />,
    self.document.getElementById('FMicroApp_SignResourceToNode') as HTMLElement,
  );
}

export default FMicroApp_SignResourceToNode;
